import { createSlice } from "@reduxjs/toolkit";

const airPorts = [];

const AirPortsSlice = createSlice({
  name: "airPorts",
  initialState: {
    airPorts,
  },
  reducers: {
    reSetAirPorts(state, action){
      state.airPorts = airPorts
    },
    setAirPorts(state, action) {
      state.airPorts = action.payload;
    },
  },
});

export const { setAirPorts,reSetAirPorts } = AirPortsSlice.actions;

export default AirPortsSlice.reducer;
